<template>
  <div class="row mx-3 px-md-3 pt-3 pb-5 mb-5 justify-content-center">
    <div class="col-12 text-center mt-3" v-if="mostrar_tiempo_restante">
        {{tiempo_restante_horas}}
      </div>
    <div class="col-12 mt-3 text-center">
      <h4>Entrevista para Perfil de Personalidad de Ingreso</h4>
    </div>
    <div class="col-md-10 mt-4">
      <div v-bind:class="loading">
        <div class="d-flex justify-content-center">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-bind:class="result">
        <div class="row">
          <div class="col-12 text-center" id="step_indicator">
              <span v-for="pregunta of examen.preguntas" class="step"></span>
          </div>
        	<div class="col-12 mt-4">
        		<form id="regForm" autocomplete="off" v-on:submit.prevent="Guardar_Avance">
    				  <div class="tab row d-none" v-for="pregunta of examen.preguntas">
                <div class="col-12 mb-5">
        				  <h5 class="text-center ">
                    {{pregunta.titulo}}
                  </h5>
                </div>
    				  	<div
                  :class="valor.class"
                  class="form-group mt-2"
                  v-for="(valor,i) in pregunta.valores">
    					    <label :for="valor.nombre">
                    {{valor.name}}
                  </label>
                  <input
                    oninput="this.className = 'form-control form-control-sm validar'"
                    v-if="
                      valor.name=='CORREO'"
                    type="email"
                    v-model="pregunta.valores[i].value" 
                    class="form-control form-control-sm validar"
                    :id="valor.nombre">
    					    <input
                    min="0" max="1000"
                    oninput="this.className = 'form-control form-control-sm validar text-uppercase'"
                    v-else-if="
                      valor.type=='text' || 
                      valor.type=='number' || 
                      valor.type=='date'"
                    :type="valor.type"
                    v-model="pregunta.valores[i].value" 
                    class="form-control form-control-sm validar text-uppercase"
                    :id="valor.nombre">
                  <select 
                    v-else-if="valor.type=='select'" 
                    v-model="pregunta.valores[i].value"
                    class="form-control form-control-sm" 
                    :id="valor.nombre">
                    <option :value="option" v-for="option of valor.options">{{option}}</option>
                  </select>
                  <textarea
                    v-else-if="valor.type=='textarea'"
                    oninput="this.className = 'form-control form-control-sm validar text-uppercase'" 
                    v-model="pregunta.valores[i].value"
                    class="form-control form-control-sm validar text-uppercase"
                    :id="valor.nombre" rows="3"></textarea>
                  <div class="row">
                    <div 
                      class="mt-3"
                      :class="condition.class"
                      v-if="condition.value_condition==valor.value" 
                      v-for="(condition,y) in valor.conditions"
                    >
                      <label :for="condition.nombre">
                        {{condition.name}}
                      </label>
                      <input
                        min="0" max="1000"
                        oninput="this.className = 'form-control form-control-sm validar text-uppercase'"
                        v-if="
                          condition.type=='text' || 
                          condition.type=='number' || 
                          condition.type=='date'"
                        :type="condition.type" 
                         v-model="valor.conditions[y].value"
                        class="form-control form-control-sm validar text-uppercase" 
                        :id="condition.nombre">
                      <select 
                        v-else-if="condition.type=='select'" 
                         v-model="valor.conditions[y].value"
                        class="form-control form-control-sm" 
                        :id="condition.nombre">
                        <option :value="option2" v-for="option2 of condition.options">{{option2}}</option>
                      </select>
                      <div class="row">
                        <div 
                          class="mt-3"
                          :class="condition2.class"
                          v-if="condition2.value_condition==condition.value" v-for="(condition2,x) in condition.conditions"
                        >
                          <label :for="condition2.nombre">
                            {{condition2.name}}
                          </label>
                          <input
                            min="0" max="1000"
                            oninput="this.className = 'form-control form-control-sm validar text-uppercase'"
                            v-if="
                              condition2.type=='text' || 
                              condition2.type=='number' || 
                              condition2.type=='date'"
                            :type="condition2.type" 
                             v-model="condition.conditions[x].value"
                            class="form-control form-control-sm validar text-uppercase" 
                            :id="condition2.nombre">
                          <select 
                            v-else-if="condition2.type=='select'" 
                             v-model="condition.conditions[x].value"
                            class="form-control form-control-sm" 
                            :id="condition2.nombre">
                            <option :value="option3" v-for="option3 of condition2.options">{{option3}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
    					  </div>
    				  </div>
    				</form>
        	</div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-3">
            <button class="btn btn-success mr-3" v-show="pregunta_actual>1" id="prevBtn" v-on:click="nextPrev(-1)">
              <i class="fas fa-arrow-circle-left"></i>
              Anterior
            </button>
            <button class="btn btn-success" id="nextBtn" v-on:click="nextPrev(1)">
              Siguiente   
              <i class="fas fa-arrow-circle-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      currentTab:0,
      production:true,
      production_active:2,
      examen:{
        idexamen:null,
        abreviatura:"entrevista",
        nombre:"Entrevista de Personalidad",
        avance:70,
        preguntas:[]
      },
      preguntas:[
      	{
      		active:true,
      		name:'datos_personales',
          titulo:'DATOS PERSONALES',
      		valores:[
      			{
      				value:'',
      				name:'NOMBRE',
              type:'text',
              class:'col-md-5 pr-1'
      			},
      			{
      				value:16,
      				name:'EDAD',
              type:'number',
              class:'col-md-1'
      			},
      			{
      				value:'HOMBRE',
      				name:'SEXO',
              type:'select',
              class:'col-md-auto',
              options:['HOMBRE','MUJER']
      			},
            {
              value:'SOLTERO',
              name:'ESTADO CIVIL',
              type:'select',
              class:'col-md-2',
              options:['SOLTERO','CASADO','DIVORSIADO','VIUDO','UNION LIBRE','OTRA']
            },
            {
              value:'',
              name:'MATRICULA',
              type:'text',
              class:'col-md-auto ml-auto',
            },
            {
              value:'',
              name:'FECHA DE NACIMIENTO',
              type:'date',
              class:'col-md-3',
            },
            {
              value:'',
              name:'LUGAR DE NACIMIENTO',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'DIRECCIÓN LOCAL',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'COLONIA',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'MUNICIPIO',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'ESTADO',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'CODIGO POSTAL',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'TEL',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'CELULAR',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'CORREO',
              type:'text',
              uppercase:false,
              class:'col-md-3',
            },
            {
              value:'',
              name:'DIRECCIÓN FORANEA',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'POBLACIÓN',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'TEL.(LADA)',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'ESCOLARIDAD',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'ESC. DE PROCEDENCIA',
              type:'text',
              class:'col-md-6',
            },
            {
              value:'NO',
              name:'¿EGRESO DE PREPARATORIA?',
              type:'select',
              class:'col-md-3',
              options:['SI','NO'],
              conditions:[
                {
                  value:4,
                  name:'SEMESTRE',
                  type:'number',
                  value_condition:'SI',
                  class:'col-12',
                },
                {
                  value:70,
                  name:'PROMEDIO PREPARATORIA',
                  value_condition:'SI',
                  type:'number',
                  class:'col-12',
                },
              ]
            },
            {
              value:'NO',
              name:'¿CAMBIO DE FACULTAD?',
              type:'select',
              class:'col-md-3',
              options:['SI','NO'],
              conditions:[
                {
                  value:'',
                  name:'¿CUAL?',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12',
                },
                {
                  value:'',
                  name:'MOTIVO DEL CAMBIO',
                  type:'text',
                  value_condition:'SI',
                  class:'col-12',
                }
              ],
            },
            {
              value:'NO',
              name:'¿ESTUDIASTE ALGUN  CURSO ADEMAS DE LA PREPA?',
              type:'select',
              class:'col-md-6',
              options:['SI','NO'],
              conditions:[
                {
                  value:'SI',
                  name:'¿LO CONCLUISTE?',
                  type:'select',
                  class:'col-12',
                  value_condition:'SI',
                  options:['SI','NO'],
                  conditions:[
                    {
                      value:'',
                      name:'¿PORQUE LO DEJASTE?',
                      value_condition:'NO',
                      type:'text',
                      class:'col-12'
                    }
                  ]
                }
              ]
            },
      		]
      	},
        {
          active:false,
          name:'datos_familiares',
          titulo:'DATOS FAMILIARES',
          valores:[
            {
              value:'SI',
              name:'¿EL PADRE VIVE?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-2',
              conditions:[
                {
                  value:'',
                  name:'FECHA DE MUERTE',
                  value_condition:'NO',
                  type:'date',
                  class:'col-12'
                }
              ]
            },
            {
              value:'SI',
              name:'¿LA MADRE VIVE?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-2',
              conditions:[
                {
                  value:'',
                  name:'FECHA DE MUERTE',
                  value_condition:'NO',
                  type:'date',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'¿TUS PADRES ESTAN SEPARADOS?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-auto',
              conditions:[
                {
                  value:'',
                  name:'DESDE QUE FECHA',
                  value_condition:'SI',
                  type:'date',
                  class:'col-12'
                }
              ]
            },
            {
              value:1,
              name:'QUÉ NÚMERO DE HIJO OCUPAS EN LA FAMILIA',
              type:'number',
              class:'col-md-auto'
            },
            {
              value:'0',
              name:'No. DE HERMANOS (ADEMÁS DE TI)',
              type:'number',
              class:'col-md-auto',
            },
            {
              value:'0',
              name:'No. DE HERMANAS (ADEMÁS DE TI)',
              type:'number',
              class:'col-md-auto',
            },
            {
              value:'',
              name:'OCUPACIÓN DEL PADRE',
              type:'text',
              class:'col-md-auto',
            },
            {
              value:'',
              name:'OCUPACIÓN DE LA MADRE',
              type:'text',
              class:'col-md-auto',
            },
            {
              value:'',
              name:'TU OCUPACIÓN (SI LA TIENES)',
              type:'text',
              class:'col-md-3',
            },
            {
              value:'',
              name:'OCUPACIÓN DE TUS HERMANOS',
              type:'text',
              class:'col-md-4',
            },
            {
              value:'',
              name:'¿CÓMO ES TU RELACION CON TUS PADRES?',
              type:'text',
              class:'col-md-5',
            },
            {
              value:'SI',
              name:'SOLTERO',
              type:'select',
              options:['SI','NO'],
              class:'col-md-11',
              conditions:[
                {
                  value:'',
                  name:'PROFESIÓN DE TU CÓNYUGE',
                  type:'text',
                  value_condition:'NO',
                  class:'col-md-4',
                },
                {
                  value:'',
                  name:'OCUPACIÓN DE TU CÓNYUGE',
                  type:'text',
                  value_condition:'NO',
                  class:'col-md-4',
                },
                {
                  value:'',
                  name:'TIEMPO DE VIVIR CON TU PAREJA',
                  type:'text',
                  value_condition:'NO',
                  class:'col-md-4',
                },
                {
                  value:'NO',
                  name:'¿ESTÁN SEPARADOS?',
                  type:'select',
                  value_condition:'NO',
                  options:['SI','NO'],
                  class:'col-12',
                  conditions:[
                    {
                      value:'',
                      name:'DESDE CUANDO',
                      value_condition:'SI',
                      type:'date',
                      class:'col-md-6',
                    },
                    {
                      value:'',
                      name:'MOTIVOS DE LA SEPARACIÓN',
                      value_condition:'SI',
                      type:'text',
                      class:'col-md-6',
                    }
                  ]
                },
                {
                  value:'NO',
                  name:'¿TIENE HIJOS?',
                  type:'select',
                  value_condition:'NO',
                  options:['SI','NO'],
                  class:'col-12',
                  conditions:[
                    {
                      value:'',
                      name:'¿CUÁNTOS?',
                      value_condition:'SI',
                      type:'number',
                      class:'col-md-6',
                    },
                    {
                      value:'',
                      name:'¿QUÉ EDAD TIENEN?',
                      value_condition:'SI',
                      type:'text',
                      class:'col-md-6',
                    }
                  ]
                },
                {
                  value:'NO',
                  name:'¿COMO CONSIDERAS QUE ES LA VIDA EN TU HOGAR? ',
                  type:'select',
                  value_condition:'NO',
                  options:['INSOPORTABLE','INFELIZ','TOLERABLE','SATISFACTORIA','MUY FELIZ'],
                  class:'col-6',
                }
              ]
            },
          ]
        },
        {
          active:false,
          name:'salud',
          titulo:'SALUD Y ESTADO FIJO',
          valores:[
            {
              value:'',
              name:'ESTATURA',
              type:'number',
              class:'col-md-2'
            },
            {
              value:'',
              name:'PESO',
              type:'number',
              class:'col-md-2'
            },
            {
              value:'BUENA',
              name:'CONDICIONES FÍSICAS O DE SALUD',
              type:'select',
              options:['EXCELENTE','BUENA','REGULAR','POBRE'],
              class:'col-md-auto'
            },
            {
              value:'NO',
              name:'¿ HAS SUBIDO O BAJADO DE PESO ÚLTIMAMENTE ?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-3'
            },
            {
              value:'NO',
              name:'¿HAS ESTADO HOSPITALIZADO ALGUNA VEZ?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-4',
              conditions:[
                {
                  value:'',
                  name:'PORQUÉ CAUSA',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'¿ TOMAS ALGÚN MEDICAMENTO ?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-auto',
              conditions:[
                {
                  value:'',
                  name:'CUÁL O CUÁLES',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'¿TIENES ALGUNA INFERIORIDAD O DESVENTAJA FÍSICA?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-auto',
              conditions:[
                {
                  value:'',
                  name:'¿CUÁL?',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'HAS ASISTIDO A TERAPIA PSICOLÓGICA',
              type:'select',
              options:['SI','NO'],
              class:'col-md-4',
              conditions:[
                {
                  value:'',
                  name:'¿PORQUE MOTIVO?',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                },
                {
                  value:'',
                  name:'¿CUÁNDO?',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                },
                {
                  value:'',
                  name:'¿POR CUANTO TIEMPO?',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                },
              ]
            },
            {
              value:'NO',
              name:'TIENE ALGUNA PREOCUPACIÓN POR TU SALUD O ESTADO FISICO?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8',
              conditions:[
                {
                  value:'',
                  name:'¿CUAL? ',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
          ]
        },
        {
          active:false,
          name:'situacion_economica',
          titulo:'SITUACIÓN ECONOMICA',
          valores:[
            {
              value:'',
              name:'¿DE QUÉ FUENTE PROVIENEN TUS INGRESOS? ',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'SI',
              name:'¿TIENES RECURSOS ECONÓMICOS PARA REALIZAR ADECUADAMENTE TUS ESTUDIOS? ',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto text-center'
            }
          ]
        },
        {
          active:false,
          name:'dificultades_problemas',
          titulo:'SUS DIFICULTADES Y PROBLEMAS',
          valores:[
            {
              value:'',
              name:'DESCRIBE LO QUE CREAS PUEDA SER PROBLEMAS O DIFICULTADES PARA TÍ EN:',
              type:'instrucciones',
              class:'col-12 text-center mb-3'
            },
            {
              value:'',
              name:'TU VIDA PERSONAL E ÍNTIMA',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'TRATO SOCIAL',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'RELACIONES FAMILIARES',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'EN TUS PLANES FUTUROS',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'EN LO QUE ACONTECE A LA SELECCIÓN DE TU PROFESIÓN',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿QUÉ HAS HECHO O ESTAS HACIENDO PARA RESOLVER TUS PROBLEMAS?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'DE QUE FORMA TE DESAHOGAS:',
              type:'instrucciones',
              class:'col-12 text-center mb-3'
            },
            {
              value:'',
              name:'CUÁNDO ESTAS ENOJADO',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'',
              name:'CUANDO ESTAS TRISTE',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'',
              name:'CUANDO ESTAS ESTRESADO',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'NO',
              name:'¿ALGUNA VEZ TE HAS SENTIDO AGREDIDO?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-6',
              conditions:[
                {
                  value:'',
                  name:'¿DE QUE FORMA REACCIONAS ANTE ESTAS SITUACIONES?',
                  value_condition:['SI'],
                  type:'text',
                  class:'col-12'
                },
              ]
            },
            {
              value:'COMES MUCHO',
              name:'¿ANTE SITUACIONES QUE TE PRODUCEN ESTRÉS, CÓMO REACCIONAS?',
              type:'select',
              options:['COMES MUCHO','DEJAS DE COMER','OTROS'],
              class:'col-md-8 mx-auto'
            },
          ]
        },
        {
          active:false,
          name:'habitos_estudio',
          titulo:'HÁBITOS DE ESTUDIO',
          valores:[
            {
              value:'',
              name:'CUALES MATERIAS DE LA PREPARATORIA:',
              type:'instrucciones',
              class:'col-12 text-center mb-3'
            },
            {
              value:'',
              name:'TE GUSTAN',
              type:'textarea',
              class:'col-md-3 text-center'
            },
            {
              value:'',
              name:'TE DISGUSTAN',
              type:'textarea',
              class:'col-md-3 text-center'
            },
            {
              value:'',
              name:'TE SON MAS FACILES',
              type:'textarea',
              class:'col-md-3 text-center'
            },
            {
              value:'',
              name:'TE SON MAS DIFÍCILES',
              type:'textarea',
              class:'col-md-3 text-center'
            },
            {
              value:'NO',
              name:'¿TIENES ALGUNA DIFICULTAD O PROBLEMA CON EL ESTUDIO?',
              options:['SI','NO'],
              type:'select',
              class:'col-md-6',
              conditions:[
                {
                  value:'',
                  name:'MATERIA',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                },
                {
                  value:'',
                  name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'¿TIENES ALGUNA DIFICULTAD O PROBLEMA CON  COMPAÑEROS?',
              options:['SI','NO'],
              type:'select',
              class:'col-md-6',
              conditions:[
                {
                  value:'',
                  name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'¿TIENES ALGUNA DIFICULTAD O PROBLEMA CON MAESTROS?',
              options:['SI','NO'],
              type:'select',
              class:'col-md-6',
              conditions:[
                {
                  value:'',
                  name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'NO',
              name:'¿TIENES DIFICULTAD O PROBLEMA CON TUS HABITOS DE ESTUDIO?',
              options:['SI','NO'],
              type:'select',
              class:'col-md-6',
              conditions:[
                {
                  value:'',
                  name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                  value_condition:'SI',
                  type:'text',
                  class:'col-12'
                }
              ]
            },
            {
              value:'',
              name:'¿EN QUÉ ACTIVIDADES ESTAS MEJOR INFORMADO?',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'EN EQUIPO',
              name:'EN TUS ACTIVIDADES PREFIERES TRABAJAR',
              options:['SOLO','EN EQUIPO'],
              type:'select',
              class:'col-md-6',
            },
            {
              value:'4',
              name:'¿CUANTAS HORAS DEDICAS AL ESTUDIO DIARIAMENTE, APARTE DE TU HORARIO DE CLASES?',
              type:'number',
              class:'col-md-8'
            },
            {
              value:'',
              name:'¿EN QUÈ FORMA ACOSTUMBRAS ESTUDIAR?',
              type:'text',
              class:'col-md-4'
            },
            {
              value:'NO',
              name:'¿DOMINAS UN SEGUNDO IDIOMA?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-4',
              conditions:[
                {
                  value:'',
                  name:'IDIOMA',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 pr-0'
                },
                {
                  value:'',
                  name:'%',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center'
                },
                {
                  value:'',
                  name:'NIVEL',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 pr-0'
                }
              ]
            },
            {
              value:'NO',
              name:'¿DOMINAS UN TERCER IDIOMA?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-4',
              conditions:[
                {
                  value:'',
                  name:'IDIOMA',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 pr-0'
                },
                {
                  value:'',
                  name:'%',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center'
                },
                {
                  value:'',
                  name:'NIVEL',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 pr-0'
                }
              ]
            },
            {
              value:'NO',
              name:'¿DOMINAS UN CUARTO IDIOMA?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-4',
              conditions:[
                {
                  value:'',
                  name:'IDIOMA',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 pr-0'
                },
                {
                  value:'',
                  name:'%',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center'
                },
                {
                  value:'',
                  name:'NIVEL',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 pr-0'
                }
              ]
            },
            {
              value:'',
              name:'¿CUANTO TIEMPO HORAS PASAS EN INTERNET?',
              type:'text',
              class:'col-md-4',
            },
            {
              value:'',
              name:'¿QUE PAGINAS SON LAS QUE MAS FRECUENTAS?',
              type:'text',
              class:'col-md-4',
            },
            {
              value:'',
              name:'¿QUE ACOSTUMBRAS BAJAR EN INTERNET?',
              type:'text',
              class:'col-md-4',
            },
          ]
        },
        {
          active:true,
          name:'vocacion_aptitudes',
          titulo:'VOCACION, APTITUDES',
          valores:[
            {
              value:'',
              name:'¿QUÉ CARRERAS QUERIAS ESTUDIAR?',
              type:'instrucciones',
              class:'col-12 mb-3 text-center'
            },
            {
              value:'',
              name:'EN TU INFANCIA',
              type:'text',
              class:'col-md-3'
            },
            {
              value:'',
              name:'EN LA PRIMARIA',
              type:'text',
              class:'col-md-3'
            },
            {
              value:'',
              name:'EN LA SECUNDARIA',
              type:'text',
              class:'col-md-3'
            },
            {
              value:'',
              name:'EN LA PREPARATORIA',
              type:'text',
              class:'col-md-3'
            },
            {
              value:'',
              name:'¿CON QUIÉN COMENTAS O COMPARTES TUS PROBLEMAS VOCACIONALES?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿CÓMO LLEGASTE A ELEGIR LA CARRERA DE PSICOLOGÍA?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿QUÉ INFORMACIÓN TIENES SOBRE LA CARRERA DE PSICOLOGIA?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿CONOCES EL PLAN DE ESTUDIOS?',
              type:'select',
              options:['SI','NO'],
              class:'col-12',
              conditions:[
                {
                  value:'',
                  name:'¿QUÉ AREA ESPECIFICA TE INTERESA EN LA CARRERA DE PSICOLOGÍA?',
                  type:'text',
                  value_condition:'SI',
                  class:'col-12'
                },
              ]
            },
            {
              value:'NO',
              name:'¿ADEMÁS DE PSICOLOGÍA, CONSIDERAS LA POSIBILIDAD DE ESTUDIAR ALGUNA OTRA CARRERA?',
              type:'select',
              options:['SI','NO'],
              class:'col-12',
              conditions:[
                {
                  value:'',
                  name:'¿CUÁL ES?',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-6'
                },
                {
                  value:'',
                  name:'¿POR QUÉ ELIMINASTE ESTA POSIBILIDAD?',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-6'
                },
              ]
            },
            {
              value:'SI',
              name:'ESCRIBE  SEIS  OCUPACIONES  EN  LAS  QUE  TE  SENTIRIAS  SATISFECHO (A) Y  FELIZ,  HÁZLO  EN  ORDEN  PREFERENCIAL SIN CONSIDERAR REMUNERACIÓN O POSICIÓN',
              type:'instrucciones',
              options:['SI','NO'],
              class:'col-12 text-center mb-0',
              conditions:[
                {
                  value:'',
                  name:'1',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center',
                },
                {
                  value:'',
                  name:'2',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center',
                },
                {
                  value:'',
                  name:'3',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center',
                },
                {
                  value:'',
                  name:'4',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center',
                },
                {
                  value:'',
                  name:'5',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center',
                },
                {
                  value:'',
                  name:'6',
                  type:'text',
                  value_condition:'SI',
                  class:'col-md-4 text-center',
                },
              ]
            },
            {
              value:'',
              name:'DESCRIBE CUAL ES TU PLAN DE VIDA:',
              type:'textarea',
              options:['SI','NO'],
              class:'col-12 text-center mt-3',
            }
          ]
        },
        {
          active:true,
          name:'caracteristicas_personales',
          titulo:'CARACTERÍSTICAS PERSONALES',
          valores:[
            {
              value:'',
              name:'¿CUALES SON TUS MEJORES CAPACIDADES Y/O  HABILIDADES?',
              type:'textarea',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'¿EN QUÉ ACTIVIDADES O TRABAJOS TE HAS DESTACADO MÁS?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿QUÉ ACTIVIDADES PREFIERES REALIZAR EN TU TIEMPO LIBRE?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿QUÉ LUGARES DE ENTRETENIMIENTO O DIVERSION ACOSTUMBRAS VISITAR?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿QUÉ TIPO DE MUSICA ESCUCHAS?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿SI PUDIERAS ENTREVISTAR A TU ARTISTA FAVORITO, QUIÉN SERÍA?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿SI TUVIERAS TIEMPO Y DINERO, QUÉ TE GUSTARÍA HACER EN TUS MOMENTOS LIBRES?',
              type:'text',
              class:'col-12'
            },
            {
              value:'NO',
              name:'¿PERTENECES A ALGÚN CLUB, GRUPO O ASOCIACIÓN?',
              type:'select',
              options:['SI','NO'],
              class:'col-md-6',
              conditions:[
                {
                  value:'',
                  name:'¿CUÁL?',
                  type:'text',
                  value_condition:'SI',
                  class:'col-12'
                }
              ]
            },
            {
              value:'',
              name:'¿CUÁLES FUERON TUS ENTRETENIMIENTOS Y AFICIONES EL AÑO PASADO?',
              type:'text',
              class:'col-12'
            },
            {
              value:'',
              name:'¿QUÉ ACTIVIDADES REALIZAS EN EL FIN DE SEMANA?',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'TE GUSTA DISFRUTAR DE LA VIDA',
              name:'IMPRESIÓN QUE TIENES ACERCA DE TU VIDA',
              type:'select',
              options:['TE GUSTA DISFRUTAR DE LA VIDA','LA TOMAS COMO VIENE','NECESITAS PLANEARLA','ES INJUSTA'],
              class:'col-md-6'
            },
            {
              value:'',
              name:'EN TU OPINIÓN ¿CUÁLES SON LOS RASGOS PRINCIPALES DE CARACTER Y/O  CONDUCTA  MAS VENTAJOSOS Y DESVENTAJOSOS QUE TIENES?',
              type:'instrucciones',
              class:'col-12 mt-4 text-center'
            },
            {
              value:'',
              name:'VENTAJOSOS',
              type:'textarea',
              class:'col-md-6'
            },
            {
              value:'',
              name:'DESVENTAJOSOS',
              type:'textarea',
              class:'col-md-6'
            },
            {
              value:'',
              name:'¿CUANTAS PAREJAS HAS TENIDO?',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'',
              name:'¿POR QUÉ HAN TERMINADO TUS RELACIONES DE PAREJA?',
              type:'text',
              class:'col-md-6'
            },
            {
              value:'',
              name:'¿CÓMO CONSIDERAS TUS RELACIONES AMOROSAS (DE PAREJA)?',
              type:'text',
              class:'col-md-6'
            },
          ]
        },
        {
          active:true,
          name:'cierto_falso',
          titulo:'CONTESTE SEGÚN SEA EL CASO',
          valores:[
            {
              value:'NO',
              name:'CREO QUE ALGUNA VEZ HERÍ A ALGUIEN CON MIS ACTOS',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'CONSUMÍ EN ALGUNA OCASIÓN ALGUNA DROGA',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'ME GUSTA GASTAR BROMAS PESADAS A LA GENTE',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'HE TOMADO FRUTAS DE UN JARDÍN O HUERTO QUE PERTENECE A OTRA PERSONA',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'HE SENTIDO MAS DE UNA VEZ CULPA POR COMER EN EXCESO',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'ME HE PELEADO CON OTROS (CON GOLPES, INSULTOS O PALABRAS OFENSIVAS)',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'FUMO MÁS DE 3 CIGARROS AL DÍA',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'ALGUNA VEZ HE PENSADO EN MORIRME',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'HAS VIVIDO ALGÚN TIPO DE VIOLENCIA',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
            {
              value:'NO',
              name:'MAS DE UNA VEZ HE ABUSADO DE EL ALCOHOL',
              type:'select',
              options:['SI','NO'],
              class:'col-md-8 mx-auto'
            },
          ]
        },
        {
          active:true,
          name:'frases',
          titulo:'COMPLETE LAS SIGUIENTES FRASES CON LO PRIMERO QUE SE LE OCURRA',
          valores:[
            {
              value:'',
              name:'SE QUE ES TONTO PERO TENGO MIEDO DE',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'CUANDO ERA NIÑO (A)',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'HARÍA CUALQUIER COSA POR OLVIDAR LA VEZ QUE',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'SI MI PADRE TAN SOLO',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'SERÍA PERFECTAMENTE FELIZ SI',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'MI MÁS GRANDE DEBILIDAD ES',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'QUISIERA PODER PERDER EL MIEDO DE',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'CUANDO ERA MÁS JOVEN ME SENTÍA CULPABLE DE',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'MIS TEMORES EN OCASIONES ME OBLIGAN A',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'LA PEOR COSA QUE HE HECHO',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'LA COMIDA PARA MI ES',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'EL EVENTO MÁS DESAGRADABLE QUE HE TENIDO ES',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'CUANDO ERA UN NIÑO (A)  MI FAMILIA',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'MI MÁS VIVIDO RECUERDO DE LA INFANCIA ES',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'ME AGRADA MI MADRE PERO ',
              type:'text',
              class:'col-md-8 mx-auto text-center'
            },
          ]
        },
        {
          active:true,
          name:'frecuencia',
          titulo:'SEÑALA CON UNA (X) EN CADA RESPUESTA, SEGÚN SEA TU CASO',
          valores:[
            {
              value:'SIEMPRE',
              name:'SIENTO QUE SOY ÚTIL Y NECESARIO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME SIENTO CALMADO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ACATO FÁCILMENTE LAS ORDENES O INDICACIONES QUE SE ME DAN',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME IRRITO CON FACILIDAD',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME RESULTA FÁCIL HACER TODO LO QUE SOLÍA HACER',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME SIENTO CON CONFIANZA EN MI MISMO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME SIENTO TRISTE',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'EN LA MAÑANA ES CUANDO MEJOR ME SIENTO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME SIENTO A PUNTO DE EXPLOTAR',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'LLORO CON FACILIDAD',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME SIENTO ABATIDO, DESANIMADO Y TRISTE',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME CANSO SIN MOTIVO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'TENGO PROBLEMAS DE SUEÑO DURANTE LA NOCHE',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME SIENTO MUY AGITADO Y ATURDIDO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'TOMO LAS DECISIONES FÁCILMENTE',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
            {
              value:'SIEMPRE',
              name:'ME ENCUENTRO INTRANQUILO Y NO PUEDO ESTAR QUIETO',
              type:'select',
              options:['SIEMPRE','CASI SIEMPRE','EN OCASIONES','CASI NUNCA','NUNCA'],
              class:'col-md-7 mx-auto text-center'
            },
          ]
        },
        {
          active:true,
          name:'comentarios_obs',
          titulo:'COMENTARIOS Y OBSERVACIONES',
          valores:[
            {
              value:'',
              name:'HAY ALGO QUE NO SE LE PREGUNTO Y LE GUSTARIA COMENTARLO',
              type:'textarea',
              class:'col-md-8 mx-auto text-center'
            },
            {
              value:'',
              name:'OBSERVACIONES',
              type:'textarea',
              class:'col-md-8 mx-auto text-center'
            },
          ]
        }
      ],
      pregunta_actual:1,
      avance:0,
    }
  },
  methods:{
    Guardar_Avance(){
      this.avance=(Number(this.currentTab)*100)/12;
      if (this.avance==100) {this.Cargando();}
      	this.$http.post('solicitudes/examen/avance',{
	        tiempo_restante:this.tiempo_restante,
	        avance:this.avance,
	        idexamen:this.examen.idexamen,
	        preguntas:this.examen.preguntas
      	})
      	.then(respuesta=>{return respuesta.json()})
      	.then(respuestaJson=>{
	        if (respuestaJson.resp=='Excelente') {
	          if(this.avance==100){
              this.$router.push({name:'Examenes'});
            }
	        }else{
	          swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
	        }
      	})
      	.catch(error=>{
        	swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
      	});
    },
  	showTab(n) {
      
  		var x = document.getElementsByClassName("tab");
  		//x[n].style.display = "block";
      $('#regForm').find('.tab').each(function(i,element){
        if (i==n) {
          $(element).removeClass('d-none');
        }
      });
  		if (n == 0) {
  		document.getElementById("prevBtn").style.display = "none";
  		} else {
  		document.getElementById("prevBtn").style.display = "inline";
  		}
  		if (n == (x.length - 1)) {
  		//document.getElementById("nextBtn").innerHTML = "Submit";
  		} else {
  		//document.getElementById("nextBtn").innerHTML = "Next";
  		}
      
  		this.fixStepIndicator(n);
  	},
  	nextPrev(n) {
      var that  =this;
  		// This function will figure out which tab to display
  		var x = document.getElementsByClassName("tab");
  		// Exit the function if any field in the current tab is invalid:
  		if (n == 1 && !this.validateForm()){
        alert('Todos los campos son obligatorios');
        return false;
      }
  		// Hide the current tab:
  		//x[this.currentTab].style.display = "none";
      $('#regForm').find('.tab').each(function(i,element){
        if (i==that.currentTab) {
          $(element).addClass('d-none');
        }
      });
  		// Increase or decrease the current tab by 1:
  		this.currentTab = this.currentTab + n;
  		// if you have reached the end of the form...
  		if (this.currentTab >= x.length) {
  		// ... the form gets submitted:
  		//document.getElementById("regForm").submit();
      this.Guardar_Avance();
  		return false;
  		}
  		// Otherwise, display the correct tab:
  		this.showTab(this.currentTab);
      if (this.production) {
        this.Guardar_Avance();
      }
  	},
  	validateForm() {
  		// This function deals with validation of the form fields
  		var x, y, i, valid = true;
  		x = document.getElementsByClassName("tab");
  		y = x[this.currentTab].getElementsByClassName("validar");
  		// A loop that checks every input field in the current tab:
  		for (i = 0; i < y.length; i++) {
    		// If a field is empty...
    		if (y[i].value == "") {
    		  // add an "invalid" class to the field:
    		  y[i].className += " invalid";
    		  // and set the current valid status to false
    		  valid = false;
    		}
  		}
  		return valid; // return the valid status
  	},
  	fixStepIndicator(n) {
  		// This function removes the "active" class of all steps...
      $('#step_indicator').find('.step').each(function(i,element){
        if (i==n) {
          $(element).addClass('active');
        }else{
          $(element).removeClass('active');
        }
      });
  	},
    Consultar_Preguntas(){
      var that = this;
      	this.Cargando();
      	this.$http.get('solicitudes/mis/examenes/entrevista')
      	.then(respuesta=>{return respuesta.json()})
      	.then(respuestaJson=>{
	        this.Listo();
	        if (respuestaJson.resp=='Excelente') {
	          this.examen=respuestaJson.examen;
	          this.total_preguntas=respuestaJson.examen.preguntas.length;
	          this.avance=respuestaJson.examen.avance;
	          if (this.examen.preguntas.length>0) {
              if (this.examen.preguntas[0].valores==null) {
                this.examen.preguntas=this.preguntas;
              }else if (this.examen.preguntas[0].valores.length==0) {
                this.examen.preguntas=this.preguntas;
              }
	          }else{
              this.examen.preguntas=this.preguntas;
            }

            if (!this.production) {
              //this.Colocar_Respuestas_Prueba();
              this.examen.preguntas=this.preguntas;
            }else{
              $(document).ready(function(){
                that.currentTab=0;
                that.showTab(that.currentTab);
              });
            }

            
	        }else{
	          swal("¡Ups!",respuestaJson.resp, "error");  
	        }
      	})
      	.catch(error=>{
	        this.Listo();
	        swal("Favor de Intentar mas tarde", "Problemas para cargar las preguntas", "error");
      	});
    },
    Colocar_Respuestas_Prueba(){
      /*
      this.examen.preguntas[0]={
        active:true,
        name:'datos_personales',
        titulo:'DATOS PERSONALES',
        valores:[
          {
            value:'1',
            name:'NOMBRE',
            type:'text',
            class:'col-md-3'
          },
          {
            value:16,
            name:'EDAD',
            type:'number',
            class:'col-md-1'
          },
          {
            value:'HOMBRE',
            name:'SEXO',
            type:'select',
            class:'col-md-2',
            options:['HOMBRE','MUJER']
          },
          {
            value:'2',
            name:'MATRICULA',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'SOLTERO',
            name:'ESTADO CIVIL',
            type:'select',
            class:'col-md-3',
            options:['SOLTERO','CASADO','DIVORSIADO','VIUDO','UNION LIBRE','OTRA']
          },
          {
            value:'1997-07-29',
            name:'FECHA DE NACIMIENTO',
            type:'date',
            class:'col-md-3',
          },
          {
            value:'4',
            name:'LUGAR DE NACIMIENTO',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'5',
            name:'DIRECCIÓN LOCAL',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'6',
            name:'COLONIA',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'7',
            name:'MUNICIPIO',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'8',
            name:'ESTADO',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'9',
            name:'CODIGO POSTAL',
            type:'text',
            class:'col-md-2',
          },
          {
            value:'10',
            name:'TEL',
            type:'text',
            class:'col-md-2',
          },
          {
            value:'11',
            name:'CELULAR',
            type:'text',
            class:'col-md-2',
          },
          {
            value:'12',
            name:'CORREO',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'13',
            name:'DIRECCIÓN FORANEA',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'14',
            name:'POBLACIÓN',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'16',
            name:'TEL.(LADA)',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'17',
            name:'ESCOLARIDAD',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'18',
            name:'ESC. DE PROCEDENCIA',
            type:'text',
            class:'col-md-6',
          },
          {
            value:'NO',
            name:'¿EGRESO DE PREPARATORIA?',
            type:'select',
            class:'col-md-3',
            options:['SI','NO'],
            conditions:[
              {
                value:4,
                name:'SEMESTRE',
                type:'number',
                value_condition:'SI',
                class:'col-12',
              },
              {
                value:70,
                name:'PROMEDIO PREPARATORIA',
                value_condition:'SI',
                type:'number',
                class:'col-12',
              },
            ]
          },
          {
            value:'NO',
            name:'¿CAMBIO DE FACULTAD?',
            type:'select',
            class:'col-md-3',
            options:['SI','NO'],
            conditions:[
              {
                value:'',
                name:'¿CUAL?',
                value_condition:'SI',
                type:'text',
                class:'col-12',
              },
              {
                value:'',
                name:'MOTIVO DEL CAMBIO',
                type:'text',
                value_condition:'SI',
                class:'col-12',
              }
            ],
          },
          {
            value:'NO',
            name:'¿ESTUDIASTE ALGUN  CURSO ADEMAS DE LA PREPA?',
            type:'select',
            class:'col-md-6',
            options:['SI','NO'],
            conditions:[
              {
                value:'SI',
                name:'¿LO CONCLUISTE?',
                type:'select',
                class:'col-12',
                value_condition:'SI',
                options:['SI','NO'],
                conditions:[
                  {
                    value:'',
                    name:'¿PORQUE LO DEJASTE?',
                    value_condition:'NO',
                    type:'text',
                    class:'col-12'
                  }
                ]
              }
            ]
          },
        ]
      }
      this.examen.preguntas[1]={
        active:false,
        name:'datos_familiares',
        titulo:'DATOS FAMILIARES',
        valores:[
          {
            value:'SI',
            name:'¿EL PADRE VIVE?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-2',
            conditions:[
              {
                value:'',
                name:'FECHA DE MUERTE',
                value_condition:'NO',
                type:'date',
                class:'col-12'
              }
            ]
          },
          {
            value:'SI',
            name:'¿LA MADRE VIVE?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-2',
            conditions:[
              {
                value:'',
                name:'FECHA DE MUERTE',
                value_condition:'NO',
                type:'date',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'¿TUS PADRES ESTAN SEPARADOS?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-auto',
            conditions:[
              {
                value:'',
                name:'DESDE QUE FECHA',
                value_condition:'SI',
                type:'date',
                class:'col-12'
              }
            ]
          },
          {
            value:2,
            name:'QUÉ NÚMERO DE HIJO OCUPAS EN LA FAMILIA',
            type:'number',
            class:'col-md-auto'
          },
          {
            value:1,
            name:'No. DE HERMANOS (ADEMÁS DE TI)',
            type:'number',
            class:'col-md-auto',
          },
          {
            value:1,
            name:'No. DE HERMANAS (ADEMÁS DE TI)',
            type:'number',
            class:'col-md-auto',
          },
          {
            value:'',
            name:'OCUPACIÓN DEL PADRE',
            type:'text',
            class:'col-md-auto',
          },
          {
            value:'',
            name:'OCUPACIÓN DE LA MADRE',
            type:'text',
            class:'col-md-auto',
          },
          {
            value:'',
            name:'TU OCUPACIÓN (SI LA TIENES)',
            type:'text',
            class:'col-md-3',
          },
          {
            value:'',
            name:'OCUPACIÓN DE TUS HERMANOS',
            type:'text',
            class:'col-md-5',
          },
          {
            value:'',
            name:'¿CÓMO ES TU RELACION CON TUS PADRES?',
            type:'text',
            class:'col-md-5',
          },
          {
            value:'SI',
            name:'SOLTERO',
            type:'select',
            options:['SI','NO'],
            class:'col-md-11',
            conditions:[
              {
                value:'',
                name:'PROFESIÓN DE TU CÓNYUGE',
                type:'text',
                value_condition:'NO',
                class:'col-md-4',
              },
              {
                value:'',
                name:'OCUPACIÓN DE TU CÓNYUGE',
                type:'text',
                value_condition:'NO',
                class:'col-md-4',
              },
              {
                value:'',
                name:'TIEMPO DE VIVIR CON TU PAREJA',
                type:'text',
                value_condition:'NO',
                class:'col-md-4',
              },
              {
                value:'NO',
                name:'¿ESTÁN SEPARADOS?',
                type:'select',
                value_condition:'NO',
                options:['SI','NO'],
                class:'col-12',
                conditions:[
                  {
                    value:'',
                    name:'DESDE CUANDO',
                    value_condition:'SI',
                    type:'date',
                    class:'col-md-6',
                  },
                  {
                    value:'',
                    name:'MOTIVOS DE LA SEPARACIÓN',
                    value_condition:'SI',
                    type:'text',
                    class:'col-md-6',
                  }
                ]
              },
              {
                value:'NO',
                name:'¿TIENE HIJOS?',
                type:'select',
                value_condition:'NO',
                options:['SI','NO'],
                class:'col-12',
                conditions:[
                  {
                    value:'',
                    name:'¿CUÁNTOS?',
                    value_condition:'SI',
                    type:'number',
                    class:'col-md-6',
                  },
                  {
                    value:'',
                    name:'¿QUÉ EDAD TIENEN?',
                    value_condition:'SI',
                    type:'text',
                    class:'col-md-6',
                  }
                ]
              },
              {
                value:'NO',
                name:'¿COMO CONSIDERAS QUE ES LA VIDA EN TU HOGAR? ',
                type:'select',
                value_condition:'NO',
                options:['INSOPORTABLE','INFELIZ','TOLERABLE','SATISFACTORIA','MUY FELIZ'],
                class:'col-6',
              }
            ]
          },
        ]
      }
      this.examen.preguntas[2]={
        active:false,
        name:'salud',
        titulo:'SALUD Y ESTADO FIJO',
        valores:[
          {
            value:'1.7',
            name:'ESTATURA',
            type:'number',
            class:'col-md-2'
          },
          {
            value:'105',
            name:'PESO',
            type:'number',
            class:'col-md-2'
          },
          {
            value:'BUENA',
            name:'CONDICIONES FÍSICAS O DE SALUD',
            type:'select',
            options:['EXCELENTE','BUENA','REGULAR','POBRE'],
            class:'col-md-auto'
          },
          {
            value:'NO',
            name:'¿ HAS SUBIDO O BAJADO DE PESO ÚLTIMAMENTE ?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-auto'
          },
          {
            value:'NO',
            name:'¿HAS ESTADO HOSPITALIZADO ALGUNA VEZ?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-4',
            conditions:[
              {
                value:'',
                name:'PORQUÉ CAUSA',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'¿ TOMAS ALGÚN MEDICAMENTO ?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-auto',
            conditions:[
              {
                value:'',
                name:'CUÁL O CUÁLES',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'¿TIENES ALGUNA INFERIORIDAD O DESVENTAJA FÍSICA?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-auto',
            conditions:[
              {
                value:'',
                name:'¿CUÁL?',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'HAS ASISTIDO A TERAPIA PSICOLÓGICA',
            type:'select',
            options:['SI','NO'],
            class:'col-md-4',
            conditions:[
              {
                value:'',
                name:'¿PORQUE MOTIVO?',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              },
              {
                value:'',
                name:'¿CUÁNDO?',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              },
              {
                value:'',
                name:'¿POR CUANTO TIEMPO?',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              },
            ]
          },
          {
            value:'NO',
            name:'TIENE ALGUNA PREOCUPACIÓN POR TU SALUD O ESTADO FISICO?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-8',
            conditions:[
              {
                value:'',
                name:'¿CUAL? ',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
        ]
      }
      this.examen.preguntas[3]={
        active:false,
        name:'situacion_economica',
        titulo:'SITUACIÓN ECONOMICA',
        valores:[
          {
            value:'3',
            name:'¿DE QUÉ FUENTE PROVIENEN TUS INGRESOS? ',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'SI',
            name:'¿TIENES RECURSOS ECONÓMICOS PARA REALIZAR ADECUADAMENTE TUS ESTUDIOS?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-8 mx-auto text-center'
          }
        ]
      }
      this.examen.preguntas[4]={
        active:false,
        name:'dificultades_problemas',
        titulo:'SUS DIFICULTADES Y PROBLEMAS',
        valores:[
          {
            value:'w',
            name:'DESCRIBE LO QUE CREAS PUEDA SER PROBLEMAS O DIFICULTADES PARA TÍ EN:',
            type:'instrucciones',
            class:'col-12 text-center mb-3'
          },
          {
            value:'2',
            name:'TU VIDA PERSONAL E ÍNTIMA',
            type:'text',
            class:'col-12'
          },
          {
            value:'3',
            name:'TRATO SOCIAL',
            type:'text',
            class:'col-12'
          },
          {
            value:'3',
            name:'RELACIONES FAMILIARES',
            type:'text',
            class:'col-12'
          },
          {
            value:'3',
            name:'EN TUS PLANES FUTUROS',
            type:'text',
            class:'col-12'
          },
          {
            value:'4',
            name:'EN LO QUE ACONTECE A LA SELECCIÓN DE TU PROFESIÓN',
            type:'text',
            class:'col-12'
          },
          {
            value:'4',
            name:'¿QUÉ HAS HECHO O ESTAS HACIENDO PARA RESOLVER TUS PROBLEMAS?',
            type:'text',
            class:'col-12'
          },
          {
            value:'4',
            name:'DE QUE FORMA TE DESAHOGAS:',
            type:'instrucciones',
            class:'col-12 text-center mb-3'
          },
          {
            value:'5',
            name:'CUÁNDO ESTAS ENOJADO',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'5',
            name:'CUANDO ESTAS TRISTE',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'56',
            name:'CUANDO ESTAS ESTRESADO',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'NO',
            name:'¿ALGUNA VEZ TE HAS SENTIDO AGREDIDO?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-6',
            conditions:[
              {
                value:'',
                name:'¿DE QUE FORMA REACCIONAS ANTE ESTAS SITUACIONES?',
                type:'text',
                value_condition:['SI'],
                class:'col-12'
              },
            ]
          },
          {
            value:'COMES MUCHO',
            name:'¿ANTE SITUACIONES QUE TE PRODUCEN ESTRÉS, CÓMO REACCIONAS?',
            type:'select',
            options:['COMES MUCHO','DEJAS DE COMER','OTROS'],
            class:'col-md-8 mx-auto'
          },
        ]
      }
      this.examen.preguntas[5]={
        active:false,
        name:'habitos_estudio',
        titulo:'HÁBITOS DE ESTUDIO',
        valores:[
          {
            value:'3',
            name:'CUALES MATERIAS DE LA PREPARATORIA:',
            type:'instrucciones',
            class:'col-12 text-center mb-3'
          },
          {
            value:'3',
            name:'TE GUSTAN',
            type:'textarea',
            class:'col-md-3 text-center'
          },
          {
            value:'4',
            name:'TE DISGUSTAN',
            type:'textarea',
            class:'col-md-3 text-center'
          },
          {
            value:'5',
            name:'TE SON MAS FACILES',
            type:'textarea',
            class:'col-md-3 text-center'
          },
          {
            value:'5',
            name:'TE SON MAS DIFÍCILES',
            type:'textarea',
            class:'col-md-3 text-center'
          },
          {
            value:'NO',
            name:'¿TIENES ALGUNA DIFICULTAD O PROBLEMA CON EL ESTUDIO?',
            options:['SI','NO'],
            type:'select',
            class:'col-md-6',
            conditions:[
              {
                value:'',
                name:'MATERIA',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              },
              {
                value:'',
                name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'¿TIENES ALGUNA DIFICULTAD O PROBLEMA CON  COMPAÑEROS?',
            options:['SI','NO'],
            type:'select',
            class:'col-md-6',
            conditions:[
              {
                value:'',
                name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'¿TIENES ALGUNA DIFICULTAD O PROBLEMA CON MAESTROS?',
            options:['SI','NO'],
            type:'select',
            class:'col-md-6',
            conditions:[
              {
                value:'',
                name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'NO',
            name:'¿TIENES DIFICULTAD O PROBLEMA CON TUS HABITOS DE ESTUDIO?',
            options:['SI','NO'],
            type:'select',
            class:'col-md-6',
            conditions:[
              {
                value:'',
                name:'¿EN QUÉ CONSISTE EL PROBLEMA? ',
                value_condition:'SI',
                type:'text',
                class:'col-12'
              }
            ]
          },
          {
            value:'4',
            name:'¿EN QUÉ ACTIVIDADES ESTAS MEJOR INFORMADO?',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'EN EQUIPO',
            name:'EN TUS ACTIVIDADES PREFIERES TRABAJAR',
            options:['SOLO','EN EQUIPO'],
            type:'select',
            class:'col-md-6',
          },
          {
            value:'4',
            name:'¿CUANTAS HORAS DEDICAS AL ESTUDIO DIARIAMENTE, APARTE DE TU HORARIO DE CLASES?',
            type:'number',
            class:'col-md-8'
          },
          {
            value:'5',
            name:'¿EN QUÈ FORMA ACOSTUMBRAS ESTUDIAR?',
            type:'text',
            class:'col-md-4'
          },
          {
            value:'NO',
            name:'¿DOMINAS UN SEGUNDO IDIOMA?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-4',
            conditions:[
              {
                value:'',
                name:'IDIOMA',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 pr-0'
              },
              {
                value:'',
                name:'%',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center'
              },
              {
                value:'',
                name:'NIVEL',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 pr-0'
              }
            ]
          },
          {
            value:'NO',
            name:'¿DOMINAS UN TERCER IDIOMA?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-4',
            conditions:[
              {
                value:'',
                name:'IDIOMA',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 pr-0'
              },
              {
                value:'',
                name:'%',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center'
              },
              {
                value:'',
                name:'NIVEL',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 pr-0'
              }
            ]
          },
          {
            value:'NO',
            name:'¿DOMINAS UN CUARTO IDIOMA?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-4',
            conditions:[
              {
                value:'',
                name:'IDIOMA',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 pr-0'
              },
              {
                value:'',
                name:'%',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center'
              },
              {
                value:'',
                name:'NIVEL',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 pr-0'
              }
            ]
          },
          {
            value:'53',
            name:'¿CUANTO TIEMPO HORAS PASAS EN INTERNET?',
            type:'text',
            class:'col-md-4',
          },
          {
            value:'43',
            name:'¿QUE PAGINAS SON LAS QUE MAS FRECUENTAS?',
            type:'text',
            class:'col-md-4',
          },
          {
            value:'43',
            name:'¿QUE ACOSTUMBRAS BAJAR EN INTERNET?',
            type:'text',
            class:'col-md-4',
          },
        ]
      }
      this.examen.preguntas[6]={
        active:true,
        name:'vocacion_aptitudes',
        titulo:'VOCACION, APTITUDES',
        valores:[
          {
            value:'3',
            name:'¿QUÉ CARRERAS QUERIAS ESTUDIAR?',
            type:'instrucciones',
            class:'col-12 mb-3 text-center'
          },
          {
            value:'4',
            name:'EN TU INFANCIA',
            type:'text',
            class:'col-md-3'
          },
          {
            value:'5',
            name:'EN LA PRIMARIA',
            type:'text',
            class:'col-md-3'
          },
          {
            value:'5',
            name:'EN LA SECUNDARIA',
            type:'text',
            class:'col-md-3'
          },
          {
            value:'43',
            name:'EN LA PREPARATORIA',
            type:'text',
            class:'col-md-3'
          },
          {
            value:'43',
            name:'¿CON QUIÉN COMENTAS O COMPARTES TUS PROBLEMAS VOCACIONALES?',
            type:'text',
            class:'col-12'
          },
          {
            value:'5',
            name:'¿CÓMO LLEGASTE A ELEGIR LA CARRERA DE PSICOLOGÍA?',
            type:'text',
            class:'col-12'
          },
          {
            value:'6',
            name:'¿QUÉ INFORMACIÓN TIENES SOBRE LA CARRERA DE PSICOLOGIA?',
            type:'text',
            class:'col-12'
          },
          {
            value:'76',
            name:'¿CONOCES EL PLAN DE ESTUDIOS?',
            type:'select',
            options:['SI','NO'],
            class:'col-12',
            conditions:[
              {
                value:'',
                name:'¿QUÉ AREA ESPECIFICA TE INTERESA EN LA CARRERA DE PSICOLOGÍA?',
                type:'text',
                value_condition:'SI',
                class:'col-12'
              },
            ]
          },
          {
            value:'NO',
            name:'¿ADEMÁS DE PSICOLOGÍA, CONSIDERAS LA POSIBILIDAD DE ESTUDIAR ALGUNA OTRA CARRERA?',
            type:'select',
            options:['SI','NO'],
            class:'col-12',
            conditions:[
              {
                value:'',
                name:'¿CUÁL ES?',
                type:'text',
                value_condition:'SI',
                class:'col-md-6'
              },
              {
                value:'',
                name:'¿POR QUÉ ELIMINASTE ESTA POSIBILIDAD?',
                type:'text',
                value_condition:'SI',
                class:'col-md-6'
              },
            ]
          },
          {
            value:'SI',
            name:'ESCRIBE  SEIS  OCUPACIONES  EN  LAS  QUE  TE  SENTIRIAS  SATISFECHO (A) Y  FELIZ,  HÁZLO  EN  ORDEN  PREFERENCIAL SIN CONSIDERAR REMUNERACIÓN O POSICIÓN',
            type:'instrucciones',
            options:['SI','NO'],
            class:'col-12 text-center mb-0',
            conditions:[
              {
                value:'',
                name:'1',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center',
              },
              {
                value:'',
                name:'2',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center',
              },
              {
                value:'',
                name:'3',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center',
              },
              {
                value:'',
                name:'4',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center',
              },
              {
                value:'',
                name:'5',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center',
              },
              {
                value:'',
                name:'6',
                type:'text',
                value_condition:'SI',
                class:'col-md-4 text-center',
              },
            ]
          },
          {
            value:'43',
            name:'DESCRIBE CUAL ES TU PLAN DE VIDA:',
            type:'textarea',
            options:['SI','NO'],
            class:'col-12 text-center mt-3',
          }
        ]
      }
      this.examen.preguntas[7]={
        active:true,
        name:'caracteristicas_personales',
        titulo:'CARACTERÍSTICAS PERSONALES',
        valores:[
          {
            value:'fe',
            name:'¿CUALES SON TUS MEJORES CAPACIDADES Y/O  HABILIDADES?',
            type:'textarea',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'fer',
            name:'¿EN QUÉ ACTIVIDADES O TRABAJOS TE HAS DESTACADO MÁS?',
            type:'text',
            class:'col-12'
          },
          {
            value:'g',
            name:'¿QUÉ ACTIVIDADES PREFIERES REALIZAR EN TU TIEMPO LIBRE?',
            type:'text',
            class:'col-12'
          },
          {
            value:'g',
            name:'¿QUÉ LUGARES DE ENTRETENIMIENTO O DIVERSION ACOSTUMBRAS VISITAR?',
            type:'text',
            class:'col-12'
          },
          {
            value:'4',
            name:'¿QUÉ TIPO DE MUSICA ESCUCHAS?',
            type:'text',
            class:'col-12'
          },
          {
            value:'5',
            name:'¿SI PUDIERAS ENTREVISTAR A TU ARTISTA FAVORITO, QUIÉN SERÍA?',
            type:'text',
            class:'col-12'
          },
          {
            value:'6',
            name:'¿SI TUVIERAS TIEMPO Y DINERO, QUÉ TE GUSTARÍA HACER EN TUS MOMENTOS LIBRES?',
            type:'text',
            class:'col-12'
          },
          {
            value:'NO',
            name:'¿PERTENECES A ALGÚN CLUB, GRUPO O ASOCIACIÓN?',
            type:'select',
            options:['SI','NO'],
            class:'col-md-6',
            conditions:[
              {
                value:'',
                name:'¿CUÁL?',
                type:'text',
                value_condition:'SI',
                class:'col-12'
              }
            ]
          },
          {
            value:'54',
            name:'¿CUÁLES FUERON TUS ENTRETENIMIENTOS Y AFICIONES EL AÑO PASADO?',
            type:'text',
            class:'col-12'
          },
          {
            value:'54',
            name:'¿QUÉ ACTIVIDADES REALIZAS EN EL FIN DE SEMANA?',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'TE GUSTA DISFRUTAR DE LA VIDA',
            name:'IMPRESIÓN QUE TIENES ACERCA DE TU VIDA',
            type:'select',
            options:['TE GUSTA DISFRUTAR DE LA VIDA','LA TOMAS COMO VIENE','NECESITAS PLANEARLA','ES INJUSTA'],
            class:'col-md-6'
          },
          {
            value:'5',
            name:'EN TU OPINIÓN ¿CUÁLES SON LOS RASGOS PRINCIPALES DE CARACTER Y/O  CONDUCTA  MAS VENTAJOSOS Y DESVENTAJOSOS QUE TIENES?',
            type:'instrucciones',
            class:'col-12 mt-4 text-center'
          },
          {
            value:'6',
            name:'VENTAJOSOS',
            type:'textarea',
            class:'col-md-6'
          },
          {
            value:'6',
            name:'DESVENTAJOSOS',
            type:'textarea',
            class:'col-md-6'
          },
          {
            value:'5',
            name:'¿CUANTAS PAREJAS HAS TENIDO?',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'5',
            name:'¿POR QUÉ HAN TERMINADO TUS RELACIONES DE PAREJA?',
            type:'text',
            class:'col-md-6'
          },
          {
            value:'54',
            name:'¿CÓMO CONSIDERAS TUS RELACIONES AMOROSAS (DE PAREJA)?',
            type:'text',
            class:'col-md-6'
          },
        ]
      }
      this.examen.preguntas[9]={
        active:true,
        name:'frases',
        titulo:'COMPLETE LAS SIGUIENTES FRASES CON LO PRIMERO QUE SE LE OCURRA',
        valores:[
          {
            value:'1',
            name:'SE QUE ES TONTO PERO TENGO MIEDO DE',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'2',
            name:'CUANDO ERA NIÑO (A)',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'3',
            name:'HARÍA CUALQUIER COSA POR OLVIDAR LA VEZ QUE',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'4',
            name:'SI MI PADRE TAN SOLO',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'5',
            name:'SERÍA PERFECTAMENTE FELIZ SI',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'6',
            name:'MI MÁS GRANDE DEBILIDAD ES',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'7',
            name:'QUISIERA PODER PERDER EL MIEDO DE',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'8',
            name:'CUANDO ERA MÁS JOVEN ME SENTÍA CULPABLE DE',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'9',
            name:'MIS TEMORES EN OCASIONES ME OBLIGAN A',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'10',
            name:'LA PEOR COSA QUE HE HECHO',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'11',
            name:'LA COMIDA PARA MI ES',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'12',
            name:'EL EVENTO MÁS DESAGRADABLE QUE HE TENIDO ES',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'13',
            name:'CUANDO ERA UN NIÑO (A)  MI FAMILIA',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'14',
            name:'MI MÁS VIVIDO RECUERDO DE LA INFANCIA ES',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'15',
            name:'ME AGRADA MI MADRE PERO ',
            type:'text',
            class:'col-md-8 mx-auto text-center'
          },
        ]
      }
      this.examen.preguntas[11]={
        active:true,
        name:'comentarios_obs',
        titulo:'COMENTARIOS Y OBSERVACIONES',
        valores:[
          {
            value:'1',
            name:'HAY ALGO QUE NO SE LE PREGUNTO Y LE GUSTARIA COMENTARLO',
            type:'textarea',
            class:'col-md-8 mx-auto text-center'
          },
          {
            value:'2',
            name:'OBSERVACIONES',
            type:'textarea',
            class:'col-md-8 mx-auto text-center'
          },
        ]
      }
      */
      var that = this;
      $(document).ready(function(){
        that.currentTab=that.production_active;
        that.showTab(that.currentTab);
      });
    },
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  },
  computed:{
    mostrar_tiempo_restante(){
      return this.$store.getters.getMostrar_Tiempo_Restante;
    },
    avance_total(){
      return this.$store.getters.getAvance_Total;
    },
    tiempo_restante(){
      return this.$store.getters.getTiempo_Restante;
    },
    tiempo_restante_horas(){
      return this.$store.getters.getTiempo_Restante_Horas;
    }
  },
  mounted(){
    this.Consultar_Preguntas();
  }
};
</script>

<style>
.step.active {
  opacity: 1;
}

/* Mark the steps that are finished and valid: */
.step.finish {
  background-color: #4CAF50;
}

.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;  
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

/* Mark input boxes that gets an error on validation: */
input.invalid {
  background-color: #ffdddd;
}

textarea.invalid {
  background-color: #ffdddd;
}

/* Hide all steps by default: */
.tab {
  *display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Entrevista/Entrevista.vue